import React, { useContext, useMemo } from 'react';
import { AnalyticsContextProps } from './interfaces';

export interface AnalyticsContextProviderProps {
    value: AnalyticsContextProps;
    children: React.ReactNode;
}

const context = React.createContext<AnalyticsContextProviderProps | null>(null);

export const AnalyticsContextProvider = ({ value, children }: AnalyticsContextProviderProps) => {
    const parentContextValue = useContext(context);
    const mergedValue = parentContextValue ? { ...parentContextValue.value, ...value } : value;

    // useMemo required - context value passed to provider.
    // React Compiler doesn't optimize context values automatically.
    const contextValue = useMemo(() => ({ value: mergedValue, children }), [mergedValue, children]);

    return <context.Provider value={contextValue}>{children}</context.Provider>;
};

export function useAnalyticsContext() {
    const contextValue = useContext(context);
    if (!contextValue) {
        return { context: null };
    }
    const { value } = contextValue;
    return { context: value };
}
